module.exports = __webpack_public_path__ + "img/astral-txt_20.ad8dc22a.svg";